import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_DOCUMENT_TYPES } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { getField, updateField } from 'vuex-map-fields'

const documentTypes = {
  namespaced: true,
  state: buildInitialState({
    documentTypeList: []
  }),
  getters: { getField },
  actions: {
    getDocumentTypes ({ commit, state }) {
      if (state.documentTypeList.length > 0) {
        return Promise.resolve(state.documentTypeList)
      }

      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DOCUMENT_TYPES })
        .then(json => json.data)
        .then(types => {
          commit('updateStatus', { status: COMPLETE })
          commit('setDocumentTypes', types)
          return types
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setDocumentTypes (state, types) {
      state.documentTypeList = types
    }
  }
}

export default documentTypes
